import { IIndicator, IInsight } from '@jumpstart/core';
import React from 'react';
import { uiExternalUrls } from '../states';
import ContentPreview from './ContentPreview';

export interface IContentPreviewIndicator {
  event: IInsight;
  indicator: IIndicator;
  id?: string;
  title?: string;
  width?: number;
  height?: number;
}

export default function ContentPreviewIndicator(props: IContentPreviewIndicator) {
  const { event, indicator, id, title, width, height } = {width: 300, height: 300, id: 'event-preview', title: 'Indicator Preview', ...props};
  return (
    <ContentPreview
      id={id}
      title={title}
      width={width}
      height={height}
      target={`scout9-beta-mobile-${event.id}-${indicator.id}`}
      src={`${uiExternalUrls.indicators(event)}`}
    />
  );
}
